<template>
    <div>
        <Modal :enable-close="false"
            v-model="mostrarModal"
            :title=" `Editar Usuario ${usuario.userPropio?'(Yo)':''}`"
            :modal-style="{ 'min-width': '600px', 'max-width': '700px'}"    
            >
            <CRow>
                <CCol md="8">
                    <CRow>
                        <CCol md="6">
                            <CInput
                                label="Rut:"
                                placeholder="Ingrese Rut"
                                v-model="usuario.rutUsuario"
                                :is-valid="usuario.rutValidadoUser"
                                @blur="validarRut(usuario.rutUsuario, usuario)"
                            ></CInput>
                        </CCol>
                        <CCol md="6">
                            <CInput
                                label="Nombre Usuario:"
                                placeholder="Ingrese Nombre de usuario"
                                v-model="usuario.userName"
                            ></CInput>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol md="6">
                            <span>
                                <CInput 
                                    label="Nombres"
                                    placeholder="Nombre"
                                    v-model="usuario.nombreUsuario"
                                />
                            </span>
                        </CCol>
                        <CCol md="6">
                            <span>
                                <CInput
                                    label="Apellidos"
                                    placeholder="Apellidos"
                                    v-model="usuario.apellidoUsuario"
                                />
                            </span>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol>
                            <CInput
                                label="Correo Electronico:"
                                placeholder="Ingrese correo"
                                v-model="usuario.mailUsuario"
                                @blur="validarMail(usuario)"
                                @keydown="validarMaximo($event,usuario.mailUsuario,'mail')"
                            ></CInput>
                        </CCol>
                    </CRow>

                </CCol>
                <CCol md="4">
                    <CRow>
                        <CCol>
                            <span>
                                <div>
                                    <CSwitch
                                        size="sm"
                                        shape="pill"
                                        class="align-middle" 
                                        color="success" 
                                        variant="outline"
                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                        :checked="usuario.habilitado"
                                        @update:checked="usuario.habilitado = !usuario.habilitado"
                                    />
                                    <label style="padding-left: 10px">Habilitados</label>
                                </div>
                                <div>
                                    <CSwitch
                                        size="sm"
                                        shape="pill"
                                        class="align-middle" 
                                        color="success" 
                                        variant="outline"
                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                        :checked="usuario.sueldoEmpresarial"
                                        @update:checked="usuario.sueldoEmpresarial = !usuario.sueldoEmpresarial"
                                    />
                                    <label style="padding-left: 10px">Ver sueldo empresarial</label>
                                </div>
                            </span>
                        </CCol>
                    </CRow>
                    
                    <hr>
                    <CRow>
                        <CCol>
                            <label>Tipo de usuario:</label>
                            <span>
                                <div>
                                    <CSwitch
                                        size="sm"
                                        class="align-middle" 
                                        color="success" 
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                        :checked="usuario.usuarioAdmin"
                                        @update:checked="usuario.usuarioAdmin = !usuario.usuarioAdmin; validarTipoUsuarioEdit('admin',usuario.usuarioAdmin,usuario)"
                                    />
                                    <label style="padding-left: 10px">Admin</label>
                                </div>
                                <div>
                                    <CSwitch
                                        size="sm"
                                        class="align-middle" 
                                        color="success" 
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                        :checked="usuario.usuarioNormal"
                                        @update:checked="usuario.usuarioNormal = !usuario.usuarioNormal; validarTipoUsuarioEdit('normal',usuario.usuarioNormal,usuario)"
                                    />
                                    <label style="padding-left: 10px">Normal</label>
                                </div>
                                <div>
                                    <CSwitch
                                        size="sm"
                                        class="align-middle" 
                                        color="success" 
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                        :checked="usuario.usuarioRevision"
                                        @update:checked="usuario.usuarioRevision = !usuario.usuarioRevision; validarTipoUsuarioEdit('revision',usuario.usuarioRevision, usuario)"
                                    />
                                    <label style="padding-left: 10px">Revision</label>
                                </div>
                            </span>
                        </CCol>
                        

                    </CRow>

                </CCol>
            </CRow>
            <CRow>
                
                <CCol>
                    
                </CCol>
            </CRow>

            <div class="vm-footer">
                <CRow>
                    <CCol>
                        <CButton
                            class="btnPrincipalVapp float-left"
                            :disabled="isEditanandoUsuario || !usuario.rutValidadoUser 
                            || !usuario.mailValidoUser 
                            || !usuario.userName.length>0
                            || !usuario.nombreUsuario.length>0
                            || !usuario.apellidoUsuario.length>0"
                            @click="editarUsuarios(usuario)"
                        >
                        
                        <CIcon v-show="isEditanandoUsuario" :content="$options.freeSet.cilLoopCircular" class="imgr" />    
                        Guardar cambios
                        </CButton>
                        <CButton
                            v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                            class="btnPrincipalVapp float-right"
                            @click="cerrarModal(usuario)"
                        >Cancelar Edicion</CButton>
                    </CCol>
                </CRow>
            </div>
        </Modal>
  </div>
</template>

<script>

import VueModal from "@kouts/vue-modal";
    import { freeSet } from '@coreui/icons'
    import cons from '@/const'
    import axios from "axios"

export default {
    name: "ModalModificarUsuario",
    freeSet,
    props: {
        mostrarModal: Boolean,
        usuario: Object,
    },
    components: {
        'Modal': VueModal,
    },
    data() {
        return {
            tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
            regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            
            userEditados: [],
            isEditanandoUsuario: false
        }
    },
    methods: {
        validarRut: function(rutCompleto,user){
            if(rutCompleto == "" || rutCompleto == null){
                user.rutValidadoUser = false
            } else{

                rutCompleto = rutCompleto.replace("‐","-");

                if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
                    return false;

                var tmp = rutCompleto.split('-');
                var digv = tmp[1]; 
                var rut = tmp[0];

                if ( digv == 'K' ) digv = 'k' ;

                user.rutValidadoUser = (this.validarDv(rut) == digv )
            }
        },
        validarMail: function(user){
            if(user.mailUsuario == "" || user.mailUsuario == null){
                user.mailValidoUser = false
            } else{
                user.mailValidoUser =  this.regMail.test(user.mailUsuario)
            }
        },
        validarMaximo: function(evt, texto, campo) {
            var limite = 10
            switch(campo){
                case "userName":
                    limite = 20;
                    break;
                case "nombre":
                    limite = 30
                    break;
                case "apellido":
                    limite = 30
                    break;
                case "mail":
                    limite = 50
                    break;
            }

            if (texto.length >= limite) {
                if (evt.keyCode >= 48 && evt.keyCode <= 90) {
                    evt.preventDefault();
                    return;
                }
            }
        },
        validarTipoUsuarioEdit: function(tipoUsuario,valor,usuario){
            if(tipoUsuario == "normal"){
                if(valor){
                    usuario.usuarioAdmin = false
                    usuario.usuarioRevision = false
                }
            }
            if(tipoUsuario == "admin"){
                    if(valor){
                    usuario.usuarioNormal = false
                    usuario.usuarioRevision = false
                    }
            }
            if(tipoUsuario == "revision"){
                if(valor){
                    usuario.usuarioAdmin = false
                    usuario.usuarioNormal = false
                }
            }
        },

        cerrarModal: function (user){

            this.usuario.userName =  user.respaldoUser.userName
            this.usuario.rutUsuario = user.respaldoUser.rutUsuario
            this.usuario.nombreUsuario = user.respaldoUser.nombreUsuario
            this.usuario.apellidoUsuario = user.respaldoUser.apellidoUsuario
            this.usuario.habilitado = user.respaldoUser.habilitado
            this.usuario.idCliente = user.respaldoUser.idCliente
            this.usuario.usuarioAdmin = user.respaldoUser.usuarioAdmin
            this.usuario.usuarioRevision = user.respaldoUser.usuarioRevision
            this.usuario.usuarioNormal = user.respaldoUser.usuarioNormal
            this.usuario.mailUsuario = user.respaldoUser.mailUsuario
            this.usuario.sueldoEmpresarial = user.respaldoUser.sueldoEmpresarial
            this.usuario.respaldoUser = {}

            this.usuario.editar = false

        },
        validarDv: function(T){
            var M=0,S=1;
            for(;T;T=Math.floor(T/10))
                S=(S+T%10*(9-M++%6))%11;
            return S?S-1:'k';
        },
        editarUsuarios: function(user){
            this.isEditanandoUsuario = true
            
            /*var encontrado = this.userEditados.find(userf => userf.idUsuario == user.idUsuario)

            if(!encontrado)
                this.userEditados.push(user)*/



            var url = cons.port+"://" + cons.ipServer + "/modificar_usuarios/"
            
            axios({
                method: "POST", 
                "url": url,
                "data": {"editados": [user]},
                "headers": {
                    'Authorization': `${this.tokenLogin}`
                }
            }).then(result => {
                
                this.estadoMensajeLista = "success"
                this.mensajeListaUsuarios = result.data
                this.monstrarMensajeListaUsuarios = true
                //this.getUsuarios()
                this.userEditados = []
                
                this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});

                this.usuario.editar = false
                
                this.$emit('getUsuarios')

            }, error => {
                this.mensajeListaUsuarios = `Problema al editar usuarios , ${error}`
                this.estadoMensajeLista = "danger"
                this.monstrarMensajeListaUsuarios = true

                this.$notification.success(error.response.data, {  timer: 10, position:"bottomRight"});
            })
            .finally(() => {
                this.isEditanandoUsuario = false
            });
        },
    }
}
</script>

